import { markProactiveMessage } from '../api';
import { muteMooTask } from '../api/moo-tasks.api';
import { markHandled, removeNudge } from './nudgeStore';

// Each action removes the nudge locally, marks the id handled so the poller
// can't re-surface it, and persists the status (best-effort — the handled-guard
// covers the session if the PATCH fails).
function resolveNudge(id: string, status: 'read' | 'dismissed'): void {
  markHandled(id);
  removeNudge(id);
  markProactiveMessage(id, { data: { status } }).catch(() => undefined);
}

/** User closed the nudge via the X. */
export function dismissNudge(id: string): void {
  resolveNudge(id, 'dismissed');
}

/** User opened the conversation — counts as read. */
export function openNudge(id: string): void {
  resolveNudge(id, 'read');
}

/**
 * User asked to stop seeing this task's nudges (OMNI-757). Resolve the open
 * nudge as dismissed *and* persist the mute so it never comes back for them.
 * The mute is best-effort like the other PATCHes — the local removal is the
 * immediate feedback, and a failed mute only means it may reappear later.
 */
export function muteNudgeTask(id: string, taskId: string): void {
  resolveNudge(id, 'dismissed');
  muteMooTask(taskId).catch(() => undefined);
}
